module.exports = __webpack_public_path__ + "static/img/27.0ed2573.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/27.gif
// module id = N7So
// module chunks = 0